import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { saveRegistrationState, getRegistrationState } from "./regisController";

export default function Register() {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState("");

  // useEffect(() => {
  //   // Load saved registration data
  //   const savedData = getRegistrationState();
  //   if (savedData) {
  //     setUsername(savedData.username || "");
  //     setEmail(savedData.email || "");
  //     setPassword(savedData.password || "");
  //     setConfirmPassword(savedData.confirmPassword || "");
  //   }
  // }, []);

  // Save data whenever form values change
  // useEffect(() => {
  //   saveRegistrationState({
  //     username,
  //     email,
  //     password,
  //     confirmPassword,
  //   });
  // }, [username, email, password, confirmPassword]);
  useEffect(() => {
    const savedData = sessionStorage.getItem("register_form_data");
    if (savedData) {
      try {
        const parsedData = JSON.parse(savedData);
        setUsername(parsedData.username || "");
        setEmail(parsedData.email || "");
        setPassword(parsedData.password || "");
        setConfirmPassword(parsedData.confirmPassword || "");
        console.log("Loaded register data from sessionStorage", parsedData);
      } catch (e) {
        console.error("Error parsing saved data", e);
      }
    }
  }, []);
  const handleRegister = (e) => {
    e.preventDefault();

    if (!username || !password || !confirmPassword) {
      setErrorMessage("Harap isi semua field yang wajib diisi.");
      return;
    }

    if (password !== confirmPassword) {
      setErrorMessage("Password dan konfirmasi password tidak cocok.");
      return;
    }

    setErrorMessage("");
    const formData = {
      username,
      email,
      password,
      confirmPassword,
    };
    
    // Use sessionStorage which persists better across navigation
    sessionStorage.setItem("register_form_data", JSON.stringify(formData));
    
    navigate("/register/details");
  };

  return (
    <div className="min-h-screen flex flex-col bg-white">
      {/* Header with back button */}
      <div className="flex items-center justify-between px-4 py-4 pt-8">
        <button
          onClick={() => {
            navigate(-1);
          }}
          className="p-2 hover:bg-gray-100 rounded-full transition-colors"
        >
          <img src="/icon-back.png" alt="Back" className="h-6 w-6" />
        </button>
        <div className="flex-1" /> {/* Spacer */}
      </div>

      {/* Scrollable content area */}
      <div className="flex-1 overflow-y-auto pb-32">
        {" "}
        {/* Added overflow-y-auto and padding bottom */}
        <div className="flex flex-col items-center px-8 py-4">
          <div className="mb-6 text-left w-full max-w-md">
            <img src="/logohallostroke.png" alt="Logo" className="h-12 mb-8" />
            <h1 className="text-2xl font-bold text-gray-900 mb-8">
              Buat akun untuk mengakses fitur secara lengkap
            </h1>
          </div>

          <div className="w-full max-w-md">
            <form onSubmit={handleRegister} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Username<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Masukkan username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">
                  E-mail
                </label>
                <input
                  type="email"
                  placeholder="Masukkan e-mail"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                />
              </div>

              {/* Password Field */}
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Password<span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Masukkan password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 pr-10"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-4 text-gray-500"
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>

              {/* Confirm Password Field */}
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Ulangi Password<span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Masukkan password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 pr-10"
                  />
                  <button
                    type="button"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    className="absolute right-3 top-4 text-gray-500"
                  >
                    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>

              {errorMessage && (
                <div className="mt-4 mb-4">
                  <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                    <div className="flex items-start">
                      <div className="flex-shrink-0">
                        <svg
                          className="h-5 w-5 text-red-400"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>
                      <div className="ml-3">
                        <p className="text-sm font-medium text-red-800">
                          {errorMessage}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <p className="text-xs text-right mt-4">
                <span className="text-red-500">*</span>
                <span className="font-semibold text-black">wajib diisi</span>
              </p>
            </form>
          </div>

          {/* Add extra space at bottom for better scrolling */}
          <div className="h-16"></div>
        </div>
      </div>

      {/* Fixed bottom buttons */}
      <div className="fixed bottom-0 left-0 right-0 bg-white px-8 pb-6 pt-4 shadow-lg border-t border-gray-100">
        <div className="w-full max-w-md mx-auto">
          <button
            onClick={handleRegister}
            className="w-full bg-blue-500 text-white py-2 rounded-md hover:bg-blue-600 transition mb-3"
          >
            Selanjutnya
          </button>
          <div className="flex items-center justify-between my-2">
            <hr className="w-full border-gray-300" />
            <span className="mx-2 text-gray-500 text-sm">atau</span>
            <hr className="w-full border-gray-300" />
          </div>
          <Link to="/login">
            <button className="w-full border border-blue-500 text-blue-500 py-2 rounded-md text-base font-medium hover:bg-blue-50 transition mt-3">
              Masuk
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}
